import {
  persistentReducedStream,
  reducer,
  actionCreator,
} from '@ardoq/rxbeach';
import type { ZoomActions } from 'tabview/assistantShared/useZoomActions';

export type AssistantBlocksState = {
  error: string | null;
};

/** A received layout could not be parsed/applied. */
export const assistantBlocksFailed = actionCreator<string>(
  '[assistantBlocks] layout failed'
);

export const assistantBlocksZoomIn = actionCreator('[assistantBlocks] zoom in');
export const assistantBlocksZoomOut = actionCreator(
  '[assistantBlocks] zoom out'
);
export const assistantBlocksZoomFit = actionCreator(
  '[assistantBlocks] zoom to fit'
);

/** Applies an expand-all or collapse-all to the groups on screen, alongside the setting. */
export const assistantBlocksExpandAll = actionCreator(
  '[assistantBlocks] expand all'
);
export const assistantBlocksCollapseAll = actionCreator(
  '[assistantBlocks] collapse all'
);

export const ASSISTANT_BLOCKS_ZOOM_ACTIONS: ZoomActions = {
  zoomIn: assistantBlocksZoomIn,
  zoomOut: assistantBlocksZoomOut,
  zoomFit: assistantBlocksZoomFit,
};

const defaultState: AssistantBlocksState = {
  error: null,
};

const setError = (
  state: AssistantBlocksState,
  error: string
): AssistantBlocksState => ({ ...state, error });

export const assistantBlocks$ = persistentReducedStream(
  'assistantBlocks$',
  defaultState,
  [reducer(assistantBlocksFailed, setError)]
);
